function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.617 11.884L16 1.503 13.833 0 6.498 10.314l-4.91-3.636L0 8.77 7.061 14l1.589-2.092-.033-.024z",
  fill: "#000"
});

function SvgUnion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNjE3MjggMTEuODg0TDE2IDEuNTAyOEwxMy44MzMxIDBMNi40OTc5MiAxMC4zMTQzTDEuNTg4NzQgNi42Nzg0MUwwIDguNzcwMjlMNy4wNjEwOCAxNEw4LjY0OTgzIDExLjkwODFMOC42MTcyOCAxMS44ODRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
export { SvgUnion as ReactComponent };